import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 2,
  style: {"display":"flex"}
}

import { computed, ref, watch } from "vue";
import { FilterDefinition } from "@/types/filter";
import { useListStore } from "@/store/lists";


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterField',
  props: {
    modelValue: {},
    definition: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const currentValue = ref<any>(props.modelValue);

const lists = useListStore();
const items = computed(() => {
  if (props.definition.type === "reflist") {
    return lists.useList(props.definition.reflist).value;
  }
  return [];
});

watch(
  () => props.modelValue,
  () => {
    currentValue.value = props.modelValue;
  },
);

const handleChange = (value: boolean) => {
  if (!value && currentValue.value !== props.modelValue) {
    emitChange();
  }
};

const emitChange = () => {
  if (Array.isArray(currentValue.value)) {
    emit("change", currentValue.value.length > 0 ? currentValue.value : null);
  } else if (currentValue.value === true || currentValue.value === false) {
    emit("change", currentValue.value);
  } else {
    emit("change", currentValue.value || null);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_ctx.definition.type === 'string')
    ? (_openBlock(), _createBlock(_component_v_text_field, {
        key: 0,
        modelValue: currentValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentValue).value = $event)),
        label: _ctx.definition.label,
        variant: "outlined",
        density: "compact",
        "hide-details": "",
        clearable: "",
        onKeydown: _withKeys(emitChange, ["enter"]),
        "onUpdate:focused": handleChange
      }, null, 8, ["modelValue", "label"]))
    : (_ctx.definition.type === 'reflist')
      ? (_openBlock(), _createBlock(_component_v_autocomplete, {
          key: 1,
          modelValue: currentValue.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentValue).value = $event)),
          label: _ctx.definition.label,
          items: items.value,
          "item-value": _ctx.definition.itemValue,
          "item-title": _ctx.definition.itemText,
          multiple: _ctx.definition.multiple,
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          clearable: "",
          "onUpdate:focused": handleChange
        }, null, 8, ["modelValue", "label", "items", "item-value", "item-title", "multiple"]))
      : (_ctx.definition.type === 'boolean')
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _createVNode(_component_v_checkbox, {
              "model-value": currentValue.value,
              label: _ctx.definition.label,
              indeterminate: currentValue.value === null || currentValue.value === undefined,
              "false-value": false,
              "true-value": true,
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              clearable: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => {
        currentValue.value = $event;
        emitChange();
      })
            }, null, 8, ["model-value", "label", "indeterminate"]),
            _createVNode(_component_v_btn, {
              style: {"margin-top":"6px","margin-left":"4px"},
              icon: "mdi-cancel",
              variant: "plain",
              density: "compact",
              onClick: _cache[3] || (_cache[3] = ($event: any) => {
        currentValue.value = undefined;
        emitChange();
      })
            })
          ]))
        : _createCommentVNode("", true)
}
}

})